let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86Baf")).then(() => parcelRequire('9STzG'));